import { render, staticRenderFns } from "./MonthlyAccounts.vue?vue&type=template&id=6ed060da&scoped=true"
import script from "./MonthlyAccounts.vue?vue&type=script&lang=js"
export * from "./MonthlyAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed060da",
  null
  
)

export default component.exports